module.exports = __webpack_public_path__ + "img/herobanner.7ff4b720.png";